module.exports = __webpack_public_path__ + "static/img/a6b6eca836eccf8c37d3b61d24d39f87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/btn.png
// module id = Ji48
// module chunks = 1